var globals: any = {};

export const set = (key: string, value: any) => {
    globals[key] = value;
}

export const get = (key: string) => {
    return globals[key];
}

export const getAll = () => {
    return globals;
}